var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-message-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-message",
    class: _vm.customClass,
    on: {
      "mouseenter": _vm.clearTimer,
      "mouseleave": _vm.startTimer
    }
  }, [_c('div', {
    class: ("el-message__group el-icon-" + _vm.type + " " + (_vm.iconClass ? 'is-with-icon' : ''))
  }, [(_vm.iconClass) ? _c('i', {
    staticClass: "el-message__icon",
    class: _vm.iconClass
  }) : _vm._e(), _vm._v(" "), _c('p', [(!_vm.iconClass) ? _c('i', {
    class: ("text-icon icon-" + _vm.type)
  }) : _vm._e(), _vm._v(_vm._s(_vm.message))]), _vm._v(" "), (_vm.showClose) ? _c('div', {
    staticClass: "el-message__closeBtn el-icon-close",
    on: {
      "click": _vm.close
    }
  }) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad663516","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/message/src/main.vue
// module id = 576
// module chunks = 13